import * as settings_trans from "@backend/settings/i18n"
import * as forms_trans from "@pdfking/forms/i18n"
import {
  CreateTypedTranslation,
  CreateTypedUseTranslation,
  CreateUseTranslation,
} from "@pdfking/i18n/components"
import * as imp_trans from "@pdfking/imposition/i18n"
import * as pdfengine_trans from "@pdfking/pdfengine/i18n"
import * as pdfview_trans from "@pdfking/pdfview/i18n"
import * as templates_trans from "@pdfking/templates/i18n"
import { RecordMerge } from "@pdfking/tfunc"
import { signal } from "@preact/signals"

const trans = RecordMerge(
  pdfengine_trans,
  settings_trans,
  imp_trans,
  forms_trans,
  pdfview_trans,
  templates_trans
)

// Same pattern as core/i18n's own demo (App.tsx): a signal, read via the
// callback passed to CreateUseTranslation/CreateI18nComponent below, so
// switching languages re-renders every call site automatically.
export const lang_signal = signal("en")

export const set_language = (lang: string) => {
  lang_signal.value = lang
}

export const useTranslationTyped = CreateTypedUseTranslation(trans, () => lang_signal.value)
export const Translate = CreateTypedTranslation(trans, () => lang_signal.value)

// For dynamic (non-literal) keys — a field id, an entity name, an error
// enum — that `useTranslationTyped`'s per-key typing can't express.
export const useTranslation = CreateUseTranslation(trans, () => lang_signal.value)
